export function employeesReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_EMPLOYEE":            
        case "UPDATE_EMPLOYEE":
            let list = Object.assign({}, state);
            list[payload.employee_id] = payload
            
            return list
        case "GET_EMPLOYEES":
            return payload
        default:
            return state;
    }
    
}